import {useSelector} from "react-redux";
import {ReduxState} from "../store/types";
import {ConfigData} from "../store/types/ConfigData";
import {useMemo} from "react";
import {IndividualType} from "../store/types/CustomerInfo";


export const usePortalUserData = (i_individual?: IndividualType | string) => {


    const {roleList} = useSelector((state: ReduxState) => state.company);

    const {timeZonesList, languagesList} = useSelector(
        (state: ReduxState) => state.generic,
    );

    const config = useSelector<ReduxState, ConfigData | undefined>(
        (state) => state.generic?.configData,
    );

    const timezoneOffset = useSelector<ReduxState, number>(
        (state) => state.generic.sessionData?.tz_offset || 0,
    );

    const userDateFormat = useSelector<ReduxState, string>(
        (state) =>
            state.generic.globalCustomerInfo?.customer_info?.out_date_format ||
            '',
    );

    const saveClicked = useSelector(
        (state: ReduxState) => state.tabs?.saveForms || false,
    );

    const editedPortalUser = useSelector(
        (state: ReduxState) => state.company.editedPortlUser,
    );

    const {isLoading, isFormSaving, apiErrors} = useSelector(
        (state: ReduxState) => state.company,
    );

    let initialValues = useMemo(
        () => ({
            login: editedPortalUser?.customer_individual_info.login || '',
            password: editedPortalUser?.customer_individual_info.password || '',
            role:
                roleList?.find(
                    (e) =>
                        e.i_role ===
                        editedPortalUser?.customer_individual_info.i_role,
                )?.name || '',
            type: editedPortalUser?.customer_individual_info.type,
            email: editedPortalUser?.customer_individual_info.email || '',
            activationDate:
                editedPortalUser?.customer_individual_info.activation_date ||
                null,
            expirationDate:
                editedPortalUser?.customer_individual_info.expiration_date ||
                null,
            timezone:
                timeZonesList.find(
                    (e) =>
                        e.i_time_zone ===
                        editedPortalUser?.customer_individual_info.i_time_zone,
                )?.time_zone_name || '',
            language:
                languagesList?.find(
                    (e) =>
                        e.iso_639_1 ===
                        editedPortalUser?.customer_individual_info.lang,
                )?.name || '',
            ipAddresses: editedPortalUser?.customer_individual_info
                .login_allowed_ip_list
                ? editedPortalUser.customer_individual_info.login_allowed_ip_list.map(
                    (e, index) => {
                        return {
                            isValueRequired: !!e.ip,
                            id: index,
                            value: e.ip,
                        };
                    },
                )
                : [
                    {
                        id: 0,
                        value: '',
                    },
                ],
            extension: editedPortalUser?.customer_individual_info?.type == 'hunt_group_supervisor' ? editedPortalUser.customer_individual_info.extensionDetails : null,
            isCurrentLoginUser: i_individual && i_individual === editedPortalUser?.customer_individual_info?.i_individual
        }),
        [editedPortalUser, timeZonesList],
    );


    if (isLoading) {
        initialValues = {
            type:'',
            login: '',
            password: '',
            role: '',
            email: '',
            activationDate: null,
            expirationDate: null,
            timezone: '',
            language: '',
            ipAddresses: [
                {
                    id: 0,
                    value: '',
                },
            ],
            extension: null,
            isCurrentLoginUser: false
        }
    }


    return {
        timezoneOffset,
        timeZonesList,
        languagesList,
        roleList,
        config,
        userDateFormat,
        saveClicked,
        isLoading,
        editedPortlUser: editedPortalUser,
        isFormSaving,
        apiErrors,
        svTypeSelected: editedPortalUser?.customer_individual_info.type == 'hunt_group_supervisor' || false,
        initialValues
    }
}